export const COFF_LINE_SPACING_DIFF_BETWEEN_FABRICJS_VIDEOCONTEXT = 1.11;
export const STYLE_PROPERTY_VALUES = {
    DEFAULT: 'Default',
    CUSTOM: 'Custom'
}

export const VIDEO_ENTITY_PROJECT = 'project'
export const VIDEO_ENTITY_TEMPLATE = 'template'

export const FABRIC_TYPES = {
    GROUP: 'group',
    ACTIVE_SELECTION: 'activeSelection'
}

export const DEFAULT_PSD_PATH = 'sample-psd-file/sample.psd'
